import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import { fetchNotifications, loaderAction, setNotifications } from '../actions';
import { restUrls } from '../constants';
import { fromStore } from '../selectors';
import { request } from '../utils';

function generateFilterParams(user) {
  const newParams = {
    status: 'sended',
    chl_containss: [],
  };

  if (user) {
    newParams.chl_containss.push(`user:${user.id}`);
  } else {
    newParams.chl_containss.push('user:none');
  }
  return newParams;
}

function* fetchNotificationsHandler() {
  yield put(loaderAction({ field: 'notifications', value: true }));
  const user = yield select(fromStore.userSelector);
  const params = generateFilterParams(user);
  const paramsList = {
    ...params,
    _sort: 'id:desc',
  };
  const notifications = yield call(request, { method: 'get', url: `${restUrls.messages}`, params: paramsList });
  yield put(setNotifications(notifications));
  yield put(loaderAction({ field: 'notifications', value: false }));
}

export default [
  takeLatest(fetchNotifications, fetchNotificationsHandler),
];
